<template>
  <Modal 
    :id="'cmp-add-invoice_projects'"
    @cancelled="onCancel"
  >
    
    <template slot="header"></template>

    <template slot="body">
      <TextField
        :id="'licence_name'"
        class="m1"
        v-bind="textFieldConfig"
        :value="licence.licence_name"
        :placeholder="$dft.capHead( $t('licence_name'))"
        @valuechanged="onTextFieldValueChange"
      />
    </template>

    <template slot="options">
        <button class="dt-button s6" @click="onCancel">Cancel</button>
        <button class="dt-button v1 s6" @click="onOkClicked">OK</button>
        
    
 
      
    </template>

  </Modal>
</template>

<script>



import { Subject } from "rxjs";


import InputField from "@/plugins/text-field/input-field";

import { waitForAnimation, subscribeSubject } from "@/utility";

import Modal from '../../../../dt-plugins/modal/modal';
import { licenceAccountsService } from '../../services/licence-accounts.service';





export default {
  props: {


  },
  components: {
    InputField,

    Modal
  },
  mixins: [
 
  ],
  // watch: {
  //   searchString: {
  //     immediate: true,
  //     handler: function(to, from) {
  //       console.log(`searchString Change to ${to} from ${from}`);
  //     }
  //   }
  // },
  data: function() {
    return {

      licence:{},
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
      },
    
     

    
    
    };
  },
  mounted:async function() {
   
    const resData= await licenceAccountsService.licenceForm(this.licence_id);
    this.licence=resData.data.licence;
    console.log("RES",resData)

  },
  computed: {

    
    hRowMarginRight: function() {
      if (this.invoice_projects.length > 380 / 28) {
        return "28px";
      }
    },
  
    licence_id: function() {
      return this.$route.query.licence_id;
    },
    licence_account_id:function(){
      return this.$route.query.licence_account_id;
    }

  },
  methods: {
    onTextFieldValueChange: function (name, value) {
      this.licence[name] = value;
    },
    onOkClicked:function(){
      console.log(this.licence['licence_name']);
      const payload = { licence_name:this.licence['licence_name'] ,duplicate:true ,licence_id:this.licence_id ,licence_account_id:this.licence_account_id };
      this.$emit("create",payload)
    },

    onCancel: function() {
  
      this.$emit("cancelled", true);
    },

  }
};


</script>

<style lang="scss" scoped>
.dt-modal--body {
  margin-left: 0px;
}

.contact-search {
  height: 30px;
  width: 290px;
}

.contact-table {
  margin-top: 10px;

  tbody {
    min-height: 380px;
  }
}

.dt-table2 {
  --body-height: 380px;
  --row-height: 28px;

  display: flex;
  flex-direction: column;

  &--head {
  }
  th.dt-table2--column {
    text-align: left;
    color: #828282;
    font-weight: 400;
  }
  &--body {
    background: #f8f8f8;

    display: flex;
    flex-direction: column;

    border: 1px solid var(--sprt-5);
    border-radius: 3px;

    .dt-table2--row {
      border-bottom: 1px solid var(--sprt-7);
    }

    max-height: var(--body-height);
    overflow: auto;
  }
  &--row {
    display: flex;
    flex-direction: row;
    padding: 5px;
    margin: 0px 10px;

    min-height: var(--row-height);
    cursor: pointer;

    &:hover {
      //background: rgb(235, 235, 235);
    }
  }
  &--column {
    flex: 1;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.dt-modal--options {

  button{
      &:first-child {
          margin-right: 10px;
      }
      &:last-child {
          margin-left:0px 10px;
      }
  }
}
</style>